<template>
  <div class="questionary">
    <section-header heading="2" ja="プリクラに関するアンケート"/>
    <div class="description">
      自動で移動しない場合は下のボタンを押してください
    </div>
    <normal-btn @click="onOrca">アンケートに回答する</normal-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '../components/NormalBtn'
import Protobuf from '../mixins/protobuf'
const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "Questionary",
  components: {
    SectionHeader,
    NormalBtn
  },
  mixins: [Protobuf],
  data () {
    return {
      playerId: 0,
      questionaryUrl: '',
    }
  },
  mounted() {
    // アンケート先URLなければTOPへ
    if(!sessionStorage.getItem('questionaryUrl')) this.$router.push('/')
    this.questionaryUrl = sessionStorage.getItem('questionaryUrl')

    const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
    const message = pb.PlayerInfoReq.create()
    const encoded = pb.PlayerInfoReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        this.playerId = decoded.playerIdString
        this.onOrca()
      })
      .catch(() => {
        this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
      })
  },
  methods: {
    onOrca() {
      const id = (this.playerId + 'purikuraonpurikuraonpurikuraonp').slice(0,32)
      const url = this.questionaryUrl + id
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.description {
  margin: 20px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
